// @ts-nocheck legacy file transformed to TS
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import uniq from 'lodash/uniq'
import { SVGIcon, Button, colors, Text } from 'ic-snacks'
import { TableProductCell } from 'legacy/dash-components/table-product-cell/TableProductCell'
import FlexRow from 'legacy/components/FlexRow'
import Dash from 'legacy/components/Dash'
import instacart from 'legacy/common/instacart'
import { withNotificationContext } from 'legacy/common/context'
import deprecatedAnalytics from 'legacy/common/deprecatedAnalytics'
import withRetailerRouter from 'legacy/common/withRouter'
import ApiResponseError from 'legacy/common/errors/ApiResponseError'
import { trackEvent } from 'utils/events/trackEvent'
import PromiseTable from 'legacy/components/Table/PromiseTable'

const ActionsContainer = styled(FlexRow)`
  justify-content: flex-end;
  width: 150px;
`

const PriceRange = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 110px;
`

const Spacer = styled.div`
  width: 20px;
`

// TODO: Revise this based on design guide
/* eslint-disable react/no-multi-comp */
function DangerButton({ children, ...others }) {
  const DARKENED_RED_BG = {
    backgroundColor: '#a02f37',
  }

  return (
    <Button
      style={{
        backgroundColor: '#c63e48',
        ':hover': DARKENED_RED_BG,
        ':focus': DARKENED_RED_BG,
        ':active': DARKENED_RED_BG,
      }}
      {...others}
    >
      {children}
    </Button>
  )
}

DangerButton.propTypes = {
  children: PropTypes.node.isRequired,
}

const getTrProps = () => ({
  style: {
    minHeight: '143px',
  },
})

@withRetailerRouter
@withNotificationContext
class ProductsTable extends Component<any> {
  /* eslint-disable react/forbid-prop-types */
  static propTypes = {
    promise: PropTypes.object.isRequired,
    notifyError: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    query: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
  }
  /* eslint-enable react/forbid-prop-types */

  state = {
    pendingItemsToDelete: {},
    confirmedItemsToDelete: {},
  }

  formatPrice = value => <span>${parseFloat(value).toFixed(2)}</span>

  trackClickedOnProduct = productId => {
    trackEvent({
      id: 'catalog.products.aisles.clicked_on_product',
      description: 'Clicked on a product link from the aisles page',
      data: { productId },
    })
  }

  onAllAislesPage = () => !this.props.match.params.aisle_id

  columns = () => [
    {
      header: 'Product name',
      Cell: ({ original }) => (
        <TableProductCell
          productId={original.id}
          productName={original.display_name}
          imageUrl={original.image_url}
          onClick={() => this.trackClickedOnProduct(original.id)}
          size="large"
        />
      ),
    },
    {
      id: 'codes',
      header: 'Codes',
      width: 150,
      Cell: ({ original }) => (
        <div>
          {uniq(original.product_codes).map(code => (
            <Text
              variant="T.14"
              style={{ marginTop: '10px', marginBottom: '10px' }}
              key={`${code}`}
            >
              {code}
            </Text>
          ))}
        </div>
      ),
    },
    {
      header: 'Availability',
      width: 150,
      Cell: ({ original }) => <div>{original.available_items_count} Stores</div>,
    },
    {
      header: '',
      width: 200,
      Cell: ({ original }) => {
        if (this.onAllAislesPage()) return null

        if (this.state.pendingItemsToDelete[original.id]) {
          return (
            <ActionsContainer>
              <SVGIcon
                name="xCircle"
                color={colors.GRAY_46}
                onClick={() => this.onCancelDeleteProduct(original.id)}
              />
              <Spacer />
              <DangerButton size="small" onClick={() => this.onConfirmDeleteProduct(original.id)}>
                Delete
              </DangerButton>
            </ActionsContainer>
          )
        }

        if (this.state.confirmedItemsToDelete[original.id]) {
          return (
            <ActionsContainer>
              <Button disabled size="small">
                Requested
              </Button>
            </ActionsContainer>
          )
        }

        return (
          <ActionsContainer>
            <SVGIcon
              name="delete"
              color={colors.GRAY_46}
              onClick={() => this.onAttemptDeleteProduct(original.id)}
            />
          </ActionsContainer>
        )
      },
    },
  ]

  onAttemptDeleteProduct = productId => {
    this.setState(state => ({
      pendingItemsToDelete: {
        ...state.pendingItemsToDelete,
        [productId]: true,
      },
    }))
  }

  onCancelDeleteProduct = productId => {
    this.setState(state => {
      const pendingItemsToDelete = { ...state.pendingItemsToDelete }
      delete pendingItemsToDelete[productId]

      return { pendingItemsToDelete }
    })
  }

  onConfirmDeleteProduct = productId => {
    const { partner_id, warehouse_id, aisle_id } = this.props.match.params

    instacart.go
      .post(`/v1/partners/${partner_id}/warehouses/${warehouse_id}/products/remove_from_aisle`, {
        data: { aisle_id: parseInt(aisle_id, 10), product_id: productId },
      })
      .then(() => {
        deprecatedAnalytics.track('product.remove_from_aisle', {
          source_type: 'single',
          source_value: productId,
        })

        this.onCancelDeleteProduct(productId)
        this.setState(state => ({
          confirmedItemsToDelete: {
            ...state.confirmedItemsToDelete,
            [productId]: true,
          },
        }))
      })
      .catch(e => {
        if (e instanceof ApiResponseError && e.errors && e.errors.length) {
          this.props.notifyError(e.errors[0])
        }
      })
  }

  render() {
    return (
      <PromiseTable
        key={this.props.query.term}
        columns={this.columns()}
        promise={this.props.promise}
        getTrProps={getTrProps}
        noDataText="No Products"
        page={this.props.page}
      />
    )
  }
}

export default ProductsTable
/* eslint-enable react/no-multi-comp */
